<template>
	<div class="classified" id="top">
		<div class="debug" v-if="isDev">
			<router-link :to="'/poster-une-annonce/?uniqid=' + classified.uniq_id"
				>Edit</router-link
			>
			<!-- <button @click="initClassified">RESET</button>
      <button @click="fakeClassified">FILL</button>
      <button @click="updateClassified">UPDATE</button> -->
			<xmp
>
        {{ getPreset }}
      </xmp>
		</div>

		<step-selector v-if="settings && !isAdmin" />
		<div class="steps" v-if="settings">
			<div class="step" v-if="step == '1' || isAdmin">
				<classified-resume v-if="isAdmin && classified.uniq_id" />
				<div class="admin-selectors" v-if="isAdmin">
					<author-selector v-if="classified.author" />
					<status-selector />
					<button
						class="button button-primary button-large"
						@click="saveClassified"
					>
						Enregistrer
					</button>
				</div>
				<profil-selector :showWarnings="showWarnings" />
				<category-selector
					v-if="classified.profil"
					:showWarnings="showWarnings"
				/>
				<mode-selector
					v-if="classified.category"
					:showWarnings="showWarnings"
				/>
				<format-selector
					v-if="classified.category && classified.mode"
					:showWarnings="showWarnings"
				/>
				<duration-selector
					v-if="classified.category && classified.format"
					:showWarnings="showWarnings"
				/>
				<membership-selector
					v-if="
						classified.duration &&
						classified.profil == 'proflib' &&
						!isCurrentCategoryFree
					"
				/>
				<div class="pa-footer" v-if="!isAdmin">
					<button
						class="bt bt-submit"
						@click="goToStep2()"
					>
						<span>Valider</span>
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
					</button>
				</div>
				<!-- .pa-footer -->
			</div>
			<div class="step" v-if="step == '2' || isAdmin">
				<classified-resume v-if="!isAdmin" />
				<content-editor v-if="classified.profil" :showWarnings="showWarnings" />
				<options-selector v-if="classified.profil" />
				<div class="admin-selectors" v-if="isAdmin">
					<button
						class="button button-primary button-large"
						@click="saveClassified"
					>
						Enregistrer
					</button>
				</div>
				<div class="pa-footer" v-if="!isAdmin">
					<div class="bt bt-prev" @click="goToStep1()">
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
						<em>Précédent</em>
					</div>
					<button
						class="bt bt-submit"
						@click="goToStep3()"
					>
						<span>Valider</span>
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
					</button>
				</div>
				<!-- .pa-footer -->
			</div>
			<div class="step" v-if="step == '3' || isAdmin">
				<classified-resume v-if="classified.category" />
				<classified-preview />
				<classified-notice v-if="!isAdmin" />
				<div class="pa-footer pa-footer--add-basket" v-if="!isAdmin">
					<div class="bt bt-prev" @click="goToStep2()">
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
						<em>Précédent</em>
					</div>
					<div
						class="bt bt-submit"
						:class="{
							disabled: getXhr,
						}"
						@click="addToBasket()"
					>
						<span>Valider et ajouter au panier</span>
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
					</div>
				</div>
				<!-- .pa-footer -->
			</div>
			<div class="step" v-if="step == 'confirmation'">
				<classified-confirmation />
			</div>
		</div>
		<!-- <xmp>
      {{ classified }}
      {{ settings }}
    </xmp> -->
	</div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import axios from "axios";
import StepSelector from "./StepSelector.vue";
import AuthorSelector from "./AuthorSelector.vue";
import StatusSelector from "./StatusSelector.vue";
import ProfilSelector from "./ProfilSelector.vue";
import CategorySelector from "./CategorySelector.vue";
import ModeSelector from "./ModeSelector.vue";
import FormatSelector from "./FormatSelector.vue";
import DurationSelector from "./DurationSelector.vue";
import MembershipSelector from "./MembershipSelector.vue";
import ContentEditor from "./ContentEditor.vue";
import OptionsSelector from "./OptionsSelector.vue";
import ClassifiedResume from "./ClassifiedResume.vue";
import ClassifiedPreview from "./ClassifiedPreview.vue";
import ClassifiedNotice from "./ClassifiedNotice.vue";
import ClassifiedConfirmation from "./ClassifiedConfirmation.vue";
export default {
	name: "classified",
	props: {
		step: {
			type: String,
			default: "1",
		},
	},
	components: {
		StepSelector,
		StatusSelector,
		AuthorSelector,
		ProfilSelector,
		CategorySelector,
		ModeSelector,
		FormatSelector,
		DurationSelector,
		MembershipSelector,
		ContentEditor,
		OptionsSelector,
		ClassifiedResume,
		ClassifiedPreview,
		ClassifiedNotice,
		ClassifiedConfirmation,
	},
	data: function () {
		return {
			debug: process.env.NODE_ENV === "development",
			showWarnings: false,
			// preset: {
			//   profil: "recruiter",
			//   category: 3441,
			//   mode: "print_web"
			// }
		};
	},
	created() {
		// mounted() {
		if (this.$route.query.preset) {
			this.$store.commit("SET_PRESET", JSON.parse(this.$route.query.preset));
		}
		this.setStep(this.step);
	},
	watch: {
		classified: function (newV, oldV) {
			if (!oldV.uniq_id && newV.uniq_id) {
				this.$cookie.set("pa-uniq_id", newV.uniq_id, 1);
			}
		},
	},
	methods: {
		...mapMutations(["initClassified"]), // "setStep",
		updateClassified() {
			this.$store.commit("FORCE_SAVE");
		},
		saveClassified() {
			this.$store.commit("FORCE_SAVE");
			window.location = "/wp-admin/edit.php?post_type=classified&message=10";
		},
		fakeClassified() {
			this.$store.commit("SET_CLASSIFIED", this.generateFakeClassified());
		},
		addToBasket() {
			const formData = new FormData();
			formData.append("uniq_id", this.classified.uniq_id);
			this.$store.commit("startXhr");

			axios
				.post(
					this.config.app.gateway + "?action=classified_v2_add_to_basket",
					formData,
					{
						headers: {
							"Content-Type": "application/json",
						},
					}
				)
				.then((response) => {
					this.$store.commit("initClassified");
					this.setStep("confirmation");
				})
				.catch((response) => {
					//
				})
				.finally(() => this.$store.commit("endXhr"));
		},
		goToStep1() {
			this.setStep("1");
		},
		goToStep2() {
			if (parseInt(this.classified.duration)) {
				this.setStep("2");
			} else {
				this.showWarnings = true;
				this.$scrollTo(".selector.missing"); //, 300, { easing: "ease" });
			}
		},
		goToStep3() {
			if (
				this.classified.title &&
				this.classified.content.length &&
				!document.querySelector(".selector.contentTooLong") &&
				this.classified.profession_id &&
				this.classified.cities.length &&
				this.classified.profil_email &&
				this.isValidEmail(this.classified.profil_email)
			) {
				this.setStep("3");
			} else {
				this.showWarnings = true;
				this.$scrollTo(".selector.missing"); //, 300, { easing: "ease" });
			}
		},
	},
	computed: {
		...mapGetters([
			"classified",
			"getPreset",
			"currentStep",
			"isDev",
			"isAdmin",
			"getXhr",
			"isCurrentCategoryFree",
		]),
		settings() {
			return this.$store.state.settings;
		},
		categories() {
			return this.$store.state.categories;
		},
	},
};
</script>

<style lang="scss" scoped>
.selector {
	.required,
	.maxLength {
		display: none;
		color: red;
	}

	&.missing {
		.required {
			display: block;
		}
	}
	&.contentTooLong {
		.maxLength {
			display: block;
		}
	}
}
.admin-selectors {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	> div {
		padding: 20px;
		flex-grow: 0;
		flex-shrink: 1;
		flex-basis: 33%;
	}
}

.bt-submit.disabled {
	background: #d5d2d3;
	border: none;
}
</style>
